import { type CompanyStore } from "services/company/companyStore";
import { type DirectorAddressStore } from "services/director/directorAddressStore";
import { type DirectorStore } from "services/director/directorStore";
import { IssueKey, type IssuesStore } from "services/issues/issuesStore";
import { QuestionsStore } from "services/questions/questionsStore";
import { DIRECTOR_FIELD_TO_QUESTION, DirectorAcnQuestion } from "./directorConstants";

export class DirectorQuestionsStore extends QuestionsStore<DirectorAcnQuestion> {
  protected _issueKey = IssueKey.Director;
  protected _issueFieldsToQuestions = DIRECTOR_FIELD_TO_QUESTION;

  constructor(
    private readonly _directorStore: DirectorStore,
    private readonly _directorAddressStore: DirectorAddressStore,
    private readonly _companyStore: CompanyStore,
    protected readonly _issuesStore: IssuesStore,
  ) {
    super(DirectorAcnQuestion, _issuesStore);
  }

  protected _getRelevantQuestion(): DirectorAcnQuestion | undefined {
    const { mainDirector } = this._directorStore;

    if (!mainDirector) {
      return DirectorAcnQuestion.Intro;
    }

    const { abnFirstTimeDirector } = this._companyStore.company ?? {};
    if (abnFirstTimeDirector === undefined || abnFirstTimeDirector === null) {
      return DirectorAcnQuestion.IsFirstTimeDirector;
    }

    if (!mainDirector.firstName || !mainDirector.lastName) {
      return DirectorAcnQuestion.Name;
    }

    if (!mainDirector.dob) {
      return DirectorAcnQuestion.Birthday;
    }

    const address = this._directorAddressStore.tryGetForDirector(mainDirector.id);
    if (!address) {
      return DirectorAcnQuestion.Address;
    }

    if (!mainDirector.tfn) {
      return DirectorAcnQuestion.TaxFileNumber;
    }

    return undefined;
  }
}
